import { ComponentButton } from './ComponentButton';
import { HrefButton as HrefButtonType } from '@/schemas/sceneDataSchema';
import useAnalytics, { eventName } from '@/hooks/use-analytics';

export const HrefButton = ({ component }: { component: HrefButtonType }) => {
  const { trackClick } = useAnalytics();

  const handleClick = () => {
    trackClick(eventName(component.id), { href: component.href, button_type: component.type });
  };

  return (
    <ComponentButton
      href={component.href}
      onClick={handleClick}
      component={component}
      asComponent='a'
      type='button'
    />
  );
};
